var _style, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserMockup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#B8B8B8;}\n\t.st1{display:none;}\n\t.st2{display:inline;}\n\t.st3{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_1_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "BG",
    className: "st0",
    width: 500,
    height: 500
  }), /*#__PURE__*/React.createElement("g", {
    id: "USER",
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M142.1,530.9c-1.1,0-2.1-0.3-3.2-0.8c-1.1-0.5-2-1.2-2.8-2s-1.3-1.7-1.6-2.8s-0.4-2.1-0.4-3.2L154,316.7 c0-1.6,0.4-2.9,1.2-4s1.8-1.8,3.2-2.4c1.3-0.5,2.6-0.8,4-0.8c1.3,0,2.5,0.3,3.6,0.8c1.6,1.1,3.2,2.1,4.8,3.2s3.3,2.1,5.2,3.2 c1.8,1.1,3.6,2.3,5.2,3.6c1.6,1.3,3.4,2.5,5.6,3.6c1.6,1.1,3.6,2.3,6,3.6c2.4,1.3,4.8,2.5,7.1,3.6c2.4,1.1,4.9,2.1,7.5,3.2 s5.6,1.9,8.7,2.4c3.2,1.1,6.2,2,9.1,2.8c2.9,0.8,5.8,1.5,8.7,2s6,0.9,9.1,1.2c3.2,0.3,6.1,0.4,8.7,0.4c3.2,0,6.3-0.1,9.5-0.4 s6.2-0.7,9.1-1.2s5.8-1.2,8.7-2c2.9-0.8,6-1.7,9.1-2.8c3.2-0.5,6.1-1.3,8.7-2.4s5.2-2.1,7.5-3.2c2.4-1.1,4.8-2.2,7.1-3.6 c2.4-1.3,4.4-2.5,6-3.6c2.1-1.1,4-2.2,5.6-3.6c1.6-1.3,3.3-2.5,5.2-3.6c1.8-1.1,3.6-2.1,5.2-3.2s3.2-2.1,4.8-3.2 c1.1-0.5,2.2-0.8,3.6-0.8c1.3,0,2.6,0.3,4,0.8c1.3,0.5,2.4,1.3,3.2,2.4c0.8,1.1,1.2,2.4,1.2,4L370,522.2c0,1.1-0.1,2.1-0.4,3.2 c-0.3,1.1-0.8,2-1.6,2.8c-0.8,0.8-1.7,1.5-2.8,2c-1.1,0.5-2.1,0.8-3.2,0.8L142.1,530.9L142.1,530.9z M337.3,253.3 c-4.8,11.1-11.4,20.9-19.8,29.4c-8.5,8.5-18.2,15.1-29.4,19.8c-11.1,4.8-23,7.1-35.7,7.1c-13.2,0-25.4-2.4-36.5-7.1 s-20.9-11.4-29.4-19.8c-8.5-8.5-15.1-18.2-19.8-29.4c-4.8-11.1-7.1-23-7.1-35.7c0-13.2,2.4-25.4,7.1-36.5 c4.8-11.1,11.4-20.9,19.8-29.4c8.5-8.5,18.2-15.1,29.4-19.8c11.1-4.8,23.3-7.1,36.5-7.1c12.7,0,24.6,2.4,35.7,7.1 c11.1,4.8,20.9,11.4,29.4,19.8c8.5,8.5,15.1,18.2,19.8,29.4c4.8,11.1,7.1,23.3,7.1,36.5C344.4,230.3,342,242.2,337.3,253.3z"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_116_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_119_",
    className: "st3",
    d: "M254.1,320.6c57.7,0,101.5-46.3,101.5-104v-29.2c0-52.8-43.1-88.6-95.9-88.6h-17.1 c-52.8,0-90.2,35.7-90.2,88.6v29.2C152.5,274.3,196.4,320.6,254.1,320.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_127_",
    className: "st3",
    d: "M302.8,351.5c-1.6,0-2.4,0-4.1,0.8c-30.9,13.8-65.8,14.6-96.7,0l-0.8,0 c-1.6-0.8-1.6-0.8-3.2-0.8c-65,0-110.5,43.1-110.5,102.4v31.7c0,6.5,2.4,19.5,9.7,19.5h306.3c6.5,0,8.9-13,8.9-19.5v-31.7 C412.5,394.5,367.8,351.5,302.8,351.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserMockup);
export default __webpack_public_path__ + "static/media/user-mockup.f53d4f521f4efabcbba9dcf6d581b05b.svg";
export { ForwardRef as ReactComponent };